export default "__VITE_ASSET__DzLXM783__"